import { type ReactElement } from 'react'
import { Container } from 'react-bootstrap'
import MaPanel from '../../common/components/MaPanel'

function Home (): ReactElement {
  return (
    <Container fluid="auto" className="ma-page">
      <MaPanel>
        <MaPanel.Body>
          <div>Home page - intentionally blank for now</div>
        </MaPanel.Body>
      </MaPanel>
    </Container>
  )
}

export default Home
